import axios from 'axios';

export default {
    pre_insercion_CostoVariableMinimo(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_infcvm.pre_insercion",
				"p_args_in": JSON.stringify({
                    "p_usuario": p_usuario
				  })
			})
	},

	recuperar_CostoVariableMinimo(p_email, p_usuario, p_poliza, p_moneda, p_ejecutivo){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_infcvm.recuperar_infcvm",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
        "p_poliza": p_poliza,
        "p_moneda": p_moneda,
        "p_ejec": p_ejecutivo
				})
		})
	},

  recuperar_CostoVariableMinimoDetalle(p_email, p_usuario, p_poliza, p_moneda, p_ejecutivo){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_infcvm.recuperar_cvmpoliza",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
        "p_poliza": p_poliza,
        "p_moneda": p_moneda,
        "p_ejec": p_ejecutivo
				})
		})
	},



}
